import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';

export const StyledContainer = styled(Container)`
  &.legal-stuff-paragraph {
    margin-top: 60px;
    margin-bottom: 60px;
  }

  &.security-paragraph {
    margin-top: 45px;
    margin-bottom: 60px;
  }
`;

export const Content = styled.div`
  p {
    margin: 30px 0;
  }

  h1,
  h2 {
    margin-bottom: 30px;
  }

  li {
    p {
      margin: 0;
    }
  }

  hr {
    border-top: 1px solid ${themeGet('colors.border-grey')};
    margin: 90px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    p {
      margin: 30px 0;
    }

    hr {
      margin: 100px 0;
    }
  }

  /* TABLE STYLING FOR PARAGRAPHS */
  table,
  table td,
  table tr,
  table thead tr th {
    border: 1px solid black;
  }

  table {
    margin: 1rem 0;
    font-size: 0.75rem;
  }

  table td {
    padding: 0.5rem;
  }

  table thead tr th {
    padding: 0.25rem 0.5rem;
  }

  table tbody tr {
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    table {
      font-size: 16px;
    }
    table td {
      padding: 0.75rem;
      width: 33%;
    }
    table thead tr th {
      padding: 0.5rem 1rem;
    }
  }
`;

export const HtmlContent = styled.div`
  p {
    margin: 30px 0;
  }

  h1,
  h2 {
    margin-bottom: 30px;
  }

  li {
    p {
      margin: 0;
    }
  }

  a {
    padding-bottom: 1px;
    border-bottom: 1px solid currentColor;
    font-weight: ${themeGet('fontWeights.medium')};

    &:hover {
      border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
      color: ${themeGet('colors.pc-red', '#E1251B')};
    }

    &.unstyled-link {
      padding-bottom: 0;
      border-bottom: none;
      font-weight: inherit;
    }
  }

  hr {
    border-top: 1px solid ${themeGet('colors.border-grey')};
    margin: 90px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    p {
      margin: 30px 0;
    }

    hr {
      margin: 100px 0;
    }
  }

  /* TABLE STYLING FOR PARAGRAPHS */
  table,
  table td,
  table tr,
  table thead tr th {
    border: 1px solid black;
  }

  table {
    margin: 1rem 0;
    font-size: 0.75rem;
  }

  table td {
    padding: 0.5rem;
  }

  table thead tr th {
    padding: 0.25rem 0.5rem;
  }

  table tbody tr {
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    table {
      font-size: 16px;
    }
    table td {
      padding: 0.75rem;
      width: 33%;
    }
    table thead tr th {
      padding: 0.5rem 1rem;
    }
  }
`;
